// 验证身份证号码
export function checkIdNum(rule, value, callback) {
  const reg =
    /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
  if (!value) {
    return callback(new Error("请输入身份证号"));
  } else if (!reg.test(value)) {
    return callback(new Error("身份证号码不正确"));
  } else {
    callback();
  }
}
export function checkPhoneNum(rule, value, callback) {
  const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
  // /^(0|86|17951)?(13[0-9]|15[012356789]|17[012356789]|18[0-9]|14[57]|19[89])[0-9]{8}$/;
  if (!value) {
    return callback(new Error("请输入手机号"));
  } else if (!reg.test(value)) {
    return callback(new Error("手机号格式不正确"));
  } else {
    callback();
  }
}

export default {
  checkId: [{ validator: checkIdNum, trigger: "blur" }],
  checkPhone: [{ required: true, validator: checkPhoneNum, trigger: "blur" }],
};
